"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _AuthProvider = _interopRequireDefault(require("../../providers/AuthProvider"));

var _AuthMachine = _interopRequireDefault(require("../../machines/AuthMachine"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Input = _interopRequireDefault(require("../Input"));

var _Select = _interopRequireDefault(require("../Select"));

var _Button = _interopRequireDefault(require("../Button"));

var _oneClub = require("../../services/oneClub");

var _validation = require("../../utils/validation");

var _index = require("../../constants/index");

var _Login = require("./Login.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * 登入組件
 */
var Login = function Login(_ref) {
  var _authState$context$re;

  var platformName = _ref.platformName;
  var useAuthDispatch = _AuthProvider.default.useAuthDispatch,
      useAuthState = _AuthProvider.default.useAuthState;
  var AuthEventType = _AuthMachine.default.eventType,
      AuthStates = _AuthMachine.default.state;
  var history = (0, _reactRouterDom.useHistory)();
  var authDispatch = useAuthDispatch();
  var authState = useAuthState();

  var _useState = (0, _react.useState)({
    password: {
      value: "",
      message: ""
    },
    account: {
      value: "",
      message: ""
    },
    edu: "",
    errorMessage: ""
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _onChange = function onChange(key, event) {
    var value = event.target.value;
    setState(_objectSpread(_objectSpread({}, state), {}, _defineProperty({
      errorMessage: ""
    }, key, {
      value: value,
      message: ""
    })));
  };

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var values, rules, _createValidator, _createValidator2, isPass, errorGroup, result;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // let cantSubmit = false;
              values = {
                account: state.account.value,
                password: state.account.value
              };
              rules = {
                account: [{
                  message: "帳號欄位不得為空",
                  validate: _validation.required
                }],
                password: [{
                  message: "密碼欄位不得為空",
                  validate: _validation.required
                }]
              };
              _createValidator = (0, _validation.createValidator)(values, rules), _createValidator2 = _slicedToArray(_createValidator, 2), isPass = _createValidator2[0], errorGroup = _createValidator2[1];
              setState(_objectSpread(_objectSpread({}, state), {}, {
                errorGroup: errorGroup
              }));

              if (!isPass) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              _context.next = 8;
              return (0, _oneClub.sendData)(state.account.value, state.password.value);

            case 8:
              result = _context.sent;

              if (!(result.code !== "SUCCESS")) {
                _context.next = 12;
                break;
              }

              setState(_objectSpread(_objectSpread({}, state), {}, {
                account: {
                  value: "",
                  message: ""
                },
                password: {
                  value: "",
                  message: ""
                },
                errorMessage: "\u767B\u5165\u5931\u6557\uFF1A".concat(result.message)
              }));
              return _context.abrupt("return");

            case 12:
              authDispatch(AuthEventType.Logging, {
                jwt: result.jwt
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var confirmHandle = function confirmHandle() {
    authDispatch(AuthEventType.SetEducation, {
      chooseEdu: state.edu
    });
  };

  var cancelHandle = function cancelHandle() {
    authDispatch(AuthEventType.LoggingOut);
  };

  (0, _react.useEffect)(function () {
    if (authState.value === AuthStates.Idle) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        account: {
          value: "",
          message: ""
        },
        password: {
          value: "",
          message: ""
        },
        errorMessage: authState.context.error || ""
      }));
    }
  }, [authState.context.error, authState.value]);
  (0, _react.useEffect)(function () {
    if (authState.value === AuthStates.LoginDone) {
      history.push("/");
    }
  }, [authState.value]);
  return /*#__PURE__*/_react.default.createElement(_Login.UiLogin, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper"
  }, state.errorMessage && /*#__PURE__*/_react.default.createElement("div", {
    className: "errorMessage"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "cancel"), state.errorMessage), !((_authState$context$re = authState.context.result) !== null && _authState$context$re !== void 0 && _authState$context$re.isNewMember) ? /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "subTitle"
  }, "Welcome!"), /*#__PURE__*/_react.default.createElement("h1", {
    className: "title"
  }, "\u5357\u4E00\u6578\u4F4D\u8CC7\u6E90\u5165\u5EAB\u5E73\u53F0"), /*#__PURE__*/_react.default.createElement("div", {
    className: "form"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "\u5E33\u865F",
    icon: "account_circle",
    placeholder: "\u8ACB\u8F38\u5165\u5E33\u865F",
    message: state.account && state.account.message,
    value: state.account && state.account.value,
    onChange: function onChange(e) {
      return _onChange("account", e);
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default.Password, {
    label: "\u5BC6\u78BC",
    icon: "account_circle",
    placeholder: "\u8ACB\u8F38\u5165\u5BC6\u78BC",
    message: state.password && state.password.message,
    value: state.password && state.password.value,
    onChange: function onChange(e) {
      return _onChange("password", e);
    }
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "blue",
    onClick: submit,
    loading: authState.context.loading
  }, "\u767B\u5165"), /*#__PURE__*/_react.default.createElement("div", {
    className: "links"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#"
  }, "\u5FD8\u8A18\u5BC6\u78BC"), /*#__PURE__*/_react.default.createElement("div", null, "|"), /*#__PURE__*/_react.default.createElement("a", {
    href: "#"
  }, "\u524D\u5F80\u8A3B\u518A \u2192"))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "iconBox"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "check_circle"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "largeTitle"
  }, "\u767B\u5165\u6210\u529F"), /*#__PURE__*/_react.default.createElement("div", null, "\u8ACB\u9078\u64C7\u6240\u5C6C\u5B78\u5236"), /*#__PURE__*/_react.default.createElement("div", {
    className: "prompt"
  }, "\u203B \u4E00\u65E6\u9078\u64C7\u5B8C\u6210\uFF0C\u82E5\u9700\u4FEE\u6539\u8ACB\u6D3D\u7CFB\u7D71\u7BA1\u7406\u54E1\uFF01"), /*#__PURE__*/_react.default.createElement(_Select.default, {
    options: authState.context.result.eduMap && authState.context.result.eduMap.map(function (item) {
      return {
        name: item.name,
        value: item.code
      };
    }) || _index.EDUCATIONAL,
    value: state.edu,
    onChange: function onChange(value) {
      return setState({
        edu: value
      });
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "btnBox"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "blue",
    onClick: confirmHandle
  }, "\u78BA\u8A8D"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "orange",
    onClick: cancelHandle
  }, "\u53D6\u6D88")))));
};

var _default = Login;
exports.default = _default;
Login.propTypes = {
  platformName: _propTypes.default.string
};